<template>
	<section id="contact" class="container contact">
		<div class="intro">
			<div class="section-head">
				<span class="label">Contact</span>
				<h2 class="cap section-title">Come train<br />with us</h2>
			</div>
			<p>
				Tell us which class you'd like to join and your email app will open with the message ready to
				send. Or reach Pablo directly:
			</p>
			<div class="quick">
				<a class="btn" :href="contact.phoneHref">
					<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2" /></svg>
					Call
				</a>
				<a class="btn btn-mat" :href="'mailto:' + contact.email">
					<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></svg>
					Email
				</a>
			</div>
			<div class="mono details">
				<a :href="contact.phoneHref">{{ contact.phoneDisplay }}</a>
				<a :href="'mailto:' + contact.email">{{ contact.email }}</a>
				<a :href="contact.instagram" target="_blank" rel="noopener">Instagram {{ contact.instagramHandle }}</a>
				<a :href="contact.facebook" target="_blank" rel="noopener">Facebook · Pablo Cerino</a>
			</div>
		</div>

		<form class="card form" @submit.prevent="send">
			<div class="field">
				<label for="c-name">Name</label>
				<input id="c-name" v-model="name" class="input" type="text" autocomplete="name" required />
			</div>
			<div class="field">
				<label for="c-email">Email</label>
				<input id="c-email" v-model="email" class="input" type="email" autocomplete="email" required />
			</div>
			<div class="field">
				<label for="c-class">Class</label>
				<select id="c-class" v-model="klass" class="input">
					<option v-for="option in classOptions" :key="option">{{ option }}</option>
				</select>
			</div>
			<div class="field">
				<label for="c-day">Preferred day <span class="optional">(optional)</span></label>
				<input id="c-day" v-model="day" class="input" type="date" />
			</div>
			<div class="field wide">
				<label for="c-msg">Message <span class="optional">(optional)</span></label>
				<textarea id="c-msg" v-model="message" class="input textarea" rows="3"></textarea>
			</div>
			<div class="wide">
				<button type="submit" class="btn">Send message</button>
			</div>
		</form>
	</section>
</template>

<script>
import { contact } from "../../data/site.js";

export default {
	data() {
		return {
			contact,
			name: "",
			email: "",
			klass: "BJJ Basics",
			day: "",
			message: "",
			classOptions: ["BJJ Basics", "BJJ · All levels", "NoGi", "Women's only", "Kids", "Private class"],
		};
	},
	methods: {
		// There is no mail backend, so the form opens the visitor's email app with everything filled in.
		send() {
			const lines = [
				`Name: ${this.name}`,
				`Email: ${this.email}`,
				`Class: ${this.klass}`,
				this.day ? `Preferred day: ${this.day}` : "",
				"",
				this.message,
			].filter((line, i) => line !== "" || i === 4);
			const subject = `Class enquiry: ${this.klass}`;
			window.location.href =
				`mailto:${contact.email}?subject=${encodeURIComponent(subject)}` +
				`&body=${encodeURIComponent(lines.join("\n"))}`;
		},
	},
};
</script>

<style scoped>
.contact {
	padding-top: 80px;
	padding-bottom: 80px;
	display: flex;
	flex-wrap: wrap;
	gap: 40px;
}

.intro {
	flex: 1 1 320px;
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.intro p {
	color: #3a3a3a;
}

.quick {
	display: none;
}

.btn svg {
	width: 18px;
	height: 18px;
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
}

.details {
	display: flex;
	flex-direction: column;
	gap: 4px;
	font-size: 15px;
}

.form {
	flex: 1.4 1 420px;
	padding: 28px;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	gap: 16px;
}

.field {
	display: flex;
	flex-direction: column;
	gap: 6px;
}

.wide {
	grid-column: 1 / -1;
}

label {
	font-size: 14px;
	font-weight: 600;
}

.optional {
	font-weight: 400;
	color: var(--muted);
}

.input {
	width: 100%;
	min-height: 48px;
	padding: 0 14px;
	border: 1px solid var(--line-strong);
	border-radius: 10px;
	background: var(--white);
	color: var(--ink);
	font: 16px var(--body);
}

.textarea {
	min-height: 96px;
	padding: 12px 14px;
	resize: vertical;
}

@media (max-width: 768px) {
	.contact {
		padding-top: 48px;
		padding-bottom: 48px;
		flex-direction: column;
		gap: 16px;
	}

	.intro {
		flex: none;
	}

	.quick {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 10px;
	}

	.form {
		flex: none;
		padding: 18px;
		grid-template-columns: minmax(0, 1fr);
		gap: 14px;
	}

	.input {
		min-height: 52px;
	}

	.form .btn {
		width: 100%;
	}
}
</style>
